import { forwardRef } from 'react';
import { clsx } from '@team/clsx';
import { RootComponent } from '../../services/root-component';
import { Props } from './types';
import { Gap, Mode } from './enums';
import { modePresets, gapPresets } from './model';
import css from './style.module.css';

export const Layout = forwardRef<HTMLDivElement, Props>(function Component(
  {
    mode = Mode.HORIZONTAL,
    gap = Gap.SMALL,
    shouldStretched = false,
    ...props
  },
  forwardedRef
) {
  return (
    <RootComponent
      {...props}
      Component="div"
      baseClassName={clsx(css.root, modePresets[mode], gapPresets[gap], {
        [css.stretched]: shouldStretched,
      })}
      role="group"
      ref={forwardedRef}
    />
  );
});
